<template>
  <div class="i-my">
    <div class="up">
      <!-- 我的地址 -->
      <div class="facab">
        <div class="oText">{{ $t('main.MyProfile') }}</div>
        <div class="tEndAdd color-635796 cPointer" @click="isEdit = true">
          + {{ $t('main.edit') }}
        </div>
      </div>
    </div>
    <div class="down">
      <el-form :model="formData" ref="formData" label-position="left" label-width="auto"
        class="demo-ruleForm" :disabled="!isEdit">
        <el-form-item :label="$t('main.nickname')" prop="nickname">
          <el-input @keyup.enter.native="editPersonInfo" v-model="formData.nickname" :placeholder="$t('main.pleaseEnter')"></el-input>
        </el-form-item>

        <el-form-item :label="$t('main.emailAccount')" prop="email">
          <el-input @keyup.enter.native="editPersonInfo" v-model="formData.email" :placeholder="$t('main.enterMail')"></el-input>
        </el-form-item>
        <el-form-item :label="$t('main.telephoneAccount')" prop="yb">
          <el-input @keyup.enter.native="editPersonInfo" v-model="formData.telephone" :placeholder="$t('main.enterTelephone')"></el-input>
        </el-form-item>
      </el-form>
      <div v-if="isEdit" style="text-align: center; margin-top: 60px;">
        <el-button class="btn" type="danger" @click="editPersonInfo">{{ $t('main.commit') }}</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import { editMember,getUserInfo} from "@/api/index";
import Cookies from "js-cookie";
export default {
  data() {
    return {
      isEdit: false,
      formData: {
        group_id:"",
        invitional_userid:"",
        username:"",
        email:"",
        telephone:"",
        expire_time:"",
        status:"",
        siteInfo:"",//根据sietInfo判断是发送验证码还是发送邮件
      }
    };
  },
  mounted(){
    this.formData = JSON.parse(Cookies.get("userinfo"));
    this.getUserInfo();
  },
  methods:{
    editPersonInfo(){
      const data = {
        "req" : {
          "id": JSON.parse(Cookies.get("userinfo")).id,
          "info":{
            email: this.formData.email,
            telephone: this.formData.telephone,
            nickname: this.formData.nickname,
          }
        }
      };
      editMember(data).then((res) => {
        if(res.rsp.code === 0) {
          this.$message({
            message: this.$t('main.operationCompletedSuccessfully'),
            type: 'success'
          })
          this.isEdit = false // 改成不可编辑
          this.getUserInfo();
          this.$store.dispatch('setUserinfo', res.data)
        } else {
          this.$message({
            message: res.rsp.msg,
            type: 'error'
          })
        }
      });
    },
    getUserInfo(){
      const params = {
        "req": {
          "id": JSON.parse(Cookies.get("userinfo")).id
        }
      };
      getUserInfo(params).then((res) => {
        if(res.rsp.code === 0) {
          this.formData = res.data;
        } else {
          this.$message({
            message: res.rsp.msg,
            type: 'error'
          })
        }
      });
    }
  }
};
</script>

<style scoped lang="less">
.i-my {
  min-height: 46.25rem;
  background: #fafafa;
  border: 1px solid #e5e5e5;

  .up {
    width: 100%;
    height: 4.375rem;
    background: #f2f2f2;
    border-bottom: 1px solid #e5e5e5;
    line-height: 4.375rem;

    .oText {
      color: #1a1a1a;
      margin-left: 1.5rem;
      cursor: pointer;
    }

    .tEndAdd {
      padding-right: 2.5rem;
    }
  }

  .down {
    padding: 3.75rem 20%;

    .btn {
      width: 12.5rem;
      background: #635796;
      border-radius: 4px;
      border-color: #635796;
      color: #ffffff;
    }
  }

  .color-635796 {
    color: #635796;
  }
}
</style>
